import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserModel } from '../models/members/user/user.model';

import { AuthModel } from '../models/auth.model';
import { LoginType, UserContext } from '../models/members/user/user-context.model';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoginProviderEnum } from '../enums/login-provider-enum';
import { ClientModel } from '../models/members/client/client.model';
import { CreateClientInfoModel } from '../models/members/client/create-client-info.model';
import { CreateUserInfoModel } from '../models/members/user/create-user-info.model';

const API_USERS_URL = `${environment.apiUrl}`;
const AI_API_URL = `${environment.aiApiUrl}`;
@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }

  login(email: string, password: string, loginType: LoginType, tenantId?: string, socialId?: string, loginProvider?: LoginProviderEnum, accessCode?: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/auth/token`, {
      username: email,
      password,
      tenantId,
      loginType: loginType,
      socialId,
      loginProvider,
      accessCode
    });
  }

  getUsersTenantList(username: string, loginType: LoginType): Observable<any> {
    return this.http.get<AuthModel>(`${API_USERS_URL}/auth/user-tenant-list?loginType=${loginType}&userName=${username}`);
  }

  refreshToken(authModel: AuthModel): Observable<AuthModel> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/auth/refresh`, {
      accessToken: authModel.jwtAccessToken?.accessToken,
      refreshToken: authModel.jwtAccessToken?.refreshToken
    });
  }

  getUserByToken(): Observable<UserModel> {
    return this.http.get<UserModel>(`${API_USERS_URL}/users`);
  }

  getUserContext(): Observable<UserContext> {
    return this.http.get<UserContext>(`${API_USERS_URL}/security`);
  }

  pingSystem(): Observable<boolean> {
    return this.http.get<boolean>(`${API_USERS_URL}/security/ping`);
  }

  logout(): Observable<any> {
    return this.http.get<any>(`${API_USERS_URL}/security/logout`, { observe: 'response' }).pipe(
      map(data => {
        if (data.status == 200) {
          return true;
        }

        return false;
      }),
      catchError(() => {
        return of(undefined);
      }));
  }

  /** Auth processes which are on the aiApiUrl Endpoint */

  signUpUser(user: CreateUserInfoModel): Observable<UserModel> {
    return this.http.post<UserModel>(`${AI_API_URL}/SignUp/user`, user);
  }

  signUpClient(client: CreateClientInfoModel): Observable<ClientModel> {
    return this.http.post<ClientModel>(`${AI_API_URL}/SignUp/client`, client);
  }

  forgotPassword(email: string, loginType: LoginType, tenantId?: string): Observable<boolean> {
    var forgotPasswordUrl: string = "";
    if (tenantId) {
      if (loginType == LoginType.User) {
        forgotPasswordUrl = `${AI_API_URL}/SignUp/user/forgot-tenant-password?loginType=${loginType}&email=${email}&tenantId=${tenantId}`;
      } else if (loginType == LoginType.Client) {
        forgotPasswordUrl = `${AI_API_URL}/SignUp/client/forgot-tenant-password?email=${email}&tenantId=${tenantId}`;
      }
    } else {
      if (loginType == LoginType.User) {
        forgotPasswordUrl = `${AI_API_URL}/SignUp/user/forgot-password?email=${email}`;
      } else if (loginType == LoginType.Client) {
        forgotPasswordUrl = `${AI_API_URL}/SignUp/client/forgot-password?userName=${email}`;
      }
    }

    return this.http.get<boolean>(`${forgotPasswordUrl}`, { observe: 'response' })
      .pipe(
        map(data => {
          if (data.status == 200) {
            return true;
          }
          return false;
        }),
        catchError(err => {
          return of(false);
        })
      )
  }
}
